export enum EnvName {
  LOCAL = 'local',
  PROD = 'production',
  TEST = 'test',
}
